module.exports = __webpack_public_path__ + "static/media/investments.6f863c97.jpg";